import axios, { type AxiosInstance } from 'axios'
import { attachAuthInterceptors } from '@/api/interceptors/authInterceptor'
import { attachCaseTransformerInterceptors } from '@/api/interceptors/caseTransformerInterceptor'
import { i18n } from '@/locales'

const createApiClient = (): AxiosInstance => {
  const client = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    withCredentials: true
  })

  client.interceptors.request.use((config) => {
    config.headers['Accept-Language'] = i18n.global.locale.value
    return config
  })

  attachCaseTransformerInterceptors(client)
  attachAuthInterceptors(client)

  return client
}

export const apiClient = createApiClient()

export { createApiClient }
